import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";

export default function ImageGalleryModal({
  show,
  images = [],
  startIndex = 0,
  onClose,
  onDelete,
}) {
  const [index, setIndex] = useState(startIndex);

  useEffect(() => {
    setIndex(startIndex);
  }, [startIndex, show]);

  if (!images.length) return null;

  const current = images[index];

  const next = () => setIndex((i) => (i + 1) % images.length);
  const prev = () => setIndex((i) => (i - 1 + images.length) % images.length);

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = current;
    link.download = "jewelry-design.png";
    link.click();
  };

  return (
    <Modal show={show} onHide={onClose} centered size="lg">
      <Modal.Body className="text-center bg-dark">
        <img
          src={current}
          alt=""
          style={{
            maxWidth: "100%",
            maxHeight: "70vh",
            borderRadius: 8,
          }}
        />
      </Modal.Body>

      <Modal.Footer className="justify-content-between">
        <div>
          <Button variant="secondary" onClick={prev}>
            ◀
          </Button>{" "}
          <Button variant="secondary" onClick={next}>
            ▶
          </Button>
        </div>

        <div>
          <Button variant="success" onClick={handleDownload}>
            Download
          </Button>{" "}
          <Button variant="danger" onClick={() => onDelete(current)}>
            Delete
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
